var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9149 11.3518C4.1195 11.3518 1.85352 9.08579 1.85352 6.29039C1.85352 3.49498 4.1195 1.229 6.9149 1.229C9.7103 1.229 11.9763 3.49498 11.9763 6.29039C11.9763 9.08579 9.7103 11.3518 6.9149 11.3518ZM6.9149 10.3395C7.98879 10.3395 9.01869 9.91289 9.77805 9.15354C10.5374 8.39418 10.964 7.36427 10.964 6.29039C10.964 5.2165 10.5374 4.18659 9.77805 3.42724C9.01869 2.66788 7.98879 2.24128 6.9149 2.24128C5.84101 2.24128 4.8111 2.66788 4.05175 3.42724C3.29239 4.18659 2.86579 5.2165 2.86579 6.29039C2.86579 7.36427 3.29239 8.39418 4.05175 9.15354C4.8111 9.91289 5.84101 10.3395 6.9149 10.3395ZM4.38421 6.79652H8.93945V7.8088H6.9149V9.32721L4.38421 6.79652ZM6.9149 4.77197V3.25356L9.44559 5.78425H4.89034V4.77197H6.9149Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1473,
    height: 12.1473,
    fill: "white",
    transform: "translate(0.841797 0.216309)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEch);
export default __webpack_public_path__ + "static/media/ech.11ffe2277fdbc2f10f992f90e7bab240.svg";
export { ForwardRef as ReactComponent };